module.exports = __webpack_public_path__ + "static/NTG_white-2861a108026f3367953a0945f7976e7c.png";